import { Component } from 'react';
import { connect } from 'react-redux';
import { RootState } from "app/redux/reducer";
import { bindActionCreators, Dispatch } from 'redux';
import { Link, RouteComponentProps } from 'react-router-dom';
import { TextField, PrimaryButton, Dropdown } from 'office-ui-fabric-react';

import { deleteActivityType, getActivityTypes, IActivityType } from 'app/services/activity-type';
import { IList, IListFilter, IListState, StatusEnum } from 'app/shared';
import { deleteRecovery, getRecoveries, updateRecovery } from 'app/services/recovery';
import PageLayout from 'containers/PageLayout';

import PageTitle from 'components/customs/PageTitle';
import BasicTable from 'components/customs/BasicTable';
import { castThunkAction } from 'app/utils/casting';
import { toggleConfirmDialog } from 'app/redux/system/actions';
import DayPickerInput from "components/customs/DayPickerInput"

function mapStateToProps(state: RootState, ownProps: RouteComponentProps) {
    return {
        ...ownProps,
        language: state.system.language,
        pageData: state.page.pageData as IList<IActivityType[]>,
        defaultLanguage: state.system.defaultLanguage
    }
}

function mapDispatchToProps(dispatch: Dispatch) {
    return bindActionCreators({
        deleteActivityType,
        getActivityTypes,
        toggleConfirmDialog,
        getRecoveries,
        updateRecovery,
        deleteRecovery
    }, dispatch);
}

type IListActivityTypeProps = ReturnType<typeof mapStateToProps> & ReturnType<typeof mapDispatchToProps>;

class ListActivityType extends Component<IListActivityTypeProps, IListState> {

    state = {
        type: "activity-type",
        filterObject: {
            title: "",
            status: 1,
            createdOn: "",
            language: this.props.defaultLanguage
        },
        pagerObject: {
            page: 1,
            descending: false,
            pageSize: 10
        },
        activeStatus: StatusEnum.Published
    }

    componentDidMount() {
        this.makeRequest({ ...this.state.pagerObject, ...this.state.filterObject })
    }

    makeRequest(options: IListFilter) {
        if (this.state.filterObject.status === StatusEnum.Deleted) {
            castThunkAction(this.props.getRecoveries(options, this.state.type))
                .then(() => {
                    this.setState({
                        activeStatus: StatusEnum.Deleted,
                    })
                })
        } else {
            castThunkAction(this.props.getActivityTypes(options)).then(() => {
                this.setState({
                    activeStatus: this.state.filterObject.status,
                })
            })
        }
    }

    searchList() {
        this.setState({
            pagerObject: {
                page: 1,
                descending: false,
                pageSize: 10
            },
        }, () => {
            this.makeRequest({
                ...this.state.pagerObject,
                ...this.state.filterObject
            })
        })
    }

    renderFilter() {
        return (
            <div className="table-filter row">
                <TextField
                    className="custom-textfield col-md-2"
                    label="Başlık İle Arama"
                    value={this.state.filterObject?.title || ""}
                    onChange={(event: any) => {
                        this.setState({
                            filterObject: {
                                ...this.state.filterObject,
                                "title": event.target.value
                            }
                        })
                    }}
                />
                <Dropdown
                    options={[
                        { key: StatusEnum.Published, text: "Yayında" },
                        { key: StatusEnum.Deleted, text: "Silinmiş" }
                    ]}
                    className="custom-dropdown col-md-2"
                    label="Duruma Göre Arama"
                    placeholder="Seçiniz"
                    selectedKey={this.state.filterObject?.status}
                    onChange={(event: any, option: any) => {
                        this.setState({
                            filterObject: {
                                ...this.state.filterObject,
                                "status": option.key
                            }
                        })
                    }}
                    calloutProps={{
                        className: "custom-dropdown-callout"
                    }}
                />
                <DayPickerInput onChange={(createdOn: string) => this.setState({
                    filterObject: {
                        ...this.state.filterObject,
                        createdOn
                    }
                })} />
                <PrimaryButton
                    text="Arama Yap"
                    className="custom-button"
                    onClick={() => this.makeRequest({ ...this.state.pagerObject, ...this.state.filterObject })}
                    styles={{
                        root: {
                            fontSize: "11px",
                            marginTop: "27px",
                            height: "37px"
                        }
                    }}
                />
            </div>
        )
    }

    renderList() {
        return (
            <BasicTable
                totalCount={this.props.pageData.totalCount}

                columns={[
                    {
                        columnName: "title",
                        text: "Etkinlik Türü Adı",
                        col: "col-md-12"
                    }
                ]}
                items={this.props.pageData.list}
                renderOperations={(item: IActivityType) => (this.state.activeStatus !== StatusEnum.Deleted ?
                    <>
                        <Link to={`/activity-type/edit/${item.id}`}><i className="icon-edit-outline"></i> Düzenle</Link>
                        <button onClick={() => {
                            this.props.toggleConfirmDialog(true, {
                                callback: () => {
                                    castThunkAction(this.props.deleteActivityType(item.id as string)).then(res => {
                                        if (res) {
                                            this.makeRequest({ ...this.state.pagerObject, ...this.state.filterObject })
                                        }
                                    })
                                }
                            })
                        }}><i className="icon-trash-outline"></i> Sil</button>
                    </> : <>
                        {/* eslint-disable-next-line */}
                        <a onClick={() => {
                            castThunkAction(this.props.updateRecovery(this.state.type, item.id as string)).then(res => {
                                if (res) {
                                    this.searchList()
                                }
                            })

                        }}><i className="icon-trash-outline"></i> Kurtar</a>
                        <button onClick={() => {
                            this.props.toggleConfirmDialog(true, {
                                callback: () => {
                                    castThunkAction(this.props.deleteRecovery(item.id as string)).then(res => {
                                        if (res) {
                                            this.searchList()
                                        }
                                    })
                                }
                            })
                        }}><i className="icon-trash-outline"></i> Kalıcı Olarak Sil</button>
                    </>
                )
                }
                showPager={true}
                pageCount={this.props.pageData.pageCount}
                onChangePageSize={(pageSize) => {
                    this.setState({ pagerObject: { ...this.state.pagerObject, pageSize } }, () => this.makeRequest({
                        ...this.state.pagerObject,
                        ...this.state.filterObject,
                        pageSize
                    }))
                }}
                onChangePager={(pageNumber) => {
                    this.setState({ pagerObject: { ...this.state.pagerObject, page: pageNumber } }, () => this.makeRequest({
                        ...this.state.pagerObject,
                        ...this.state.filterObject,
                        page: pageNumber
                    }))
                }}
                pageIndex={this.state.pagerObject.page - 1}
            />
        )
    }

    render() {
        return (
            <PageLayout history={this.props.history} match={this.props.match} location={this.props.location}>
                <div className="page push-all">
                    <PageTitle
                        title="Etkinlik Türü Yönetimi"
                        subTitle="Tüm etkinlik türlerini aşağıdan görüntüleyebilir, düzenleme yapabilir veya yeni bir etkinlik türü ekleyebilirsiniz."
                        backUrl="/"
                        showBack
                        history={this.props.history}
                    />
                    <PrimaryButton
                        onClick={() => this.props.history.push("/activity-type/create")}
                        iconProps={{ iconName: "Add" }}
                        className="absolute-create"
                        text="Yeni Etkinlik Türü Ekle"
                        styles={{
                            root: {
                                background: "#62a98e",
                                borderColor: "#5b9e85",
                                color: "#fff"
                            },
                            rootHovered: {
                                background: "#5b9e85",
                                borderColor: "#5b9e85"
                            },
                            rootDisabled: {
                                background: "#ececec"
                            }
                        }}
                    />
                    {this.renderFilter()}
                    {this.renderList()}
                </div>
            </PageLayout>
        )
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ListActivityType);